import React, { useCallback } from 'react';
import { Button, Row, Col } from 'reactstrap';
import _ from 'lodash';
import { connect } from 'react-redux';

import { Intl, LocalTable, ModalForm } from 'components';
import { handlePromise } from 'utils';
import ListPhoneNumbersService from 'api/ListPhoneNumbers';
import SettingsActions from 'store/reducers/Settings';

const ContactModal = ( {
  data, modalTitle, translateTitle = true, open, onClose, toggleLoading, downloadId,
} ) => {
  const exportPhones = useCallback( async () => {
    toggleLoading( true );

    const [errors, response, responseData] = await handlePromise(
      downloadId
        ? ListPhoneNumbersService.getListPhoneNumber( downloadId, { download: true } )
        : ListPhoneNumbersService.exportListPhoneNumbers( {
          phoneNumbers: _.map( data, ( contact ) => ( {
            nameId: contact.nameId,
            phoneNumber: contact.phoneNumber,
          } ) ),
        } ),
    );
    toggleLoading( false );
    if ( !response.ok ) return _.isString( errors ) ? 'errors' : 'apiError';
    window.open( responseData.uri );
  }, [data, downloadId, toggleLoading] );

  return (
    <ModalForm
      title={modalTitle}
      translateTitle={translateTitle}
      size="md"
      open={open}
      showErrorsInHeader
      onClose={onClose}
      onSubmit={exportPhones}
      footer={(
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
          onClick={onClose}
        >
          <Intl id="okBtn" />
        </Button>
      )}
    >
      <Row className="my-3">
        <Col md="auto" className="m-auto">
          <div className="campaign-wizard-table">
            <LocalTable
              data={data.length < 5
                ? data.concat( new Array( 5 - data.length ).fill( { } ) )
                : data}
              manualPagination
              onlyTable
              columns={[
                {
                  Header: 'name',
                  accessor: 'nameId',
                  customWidth: 200,
                },
                {
                  Header: <Intl
                    id="phonesTotal"
                    values={{ total: data.length }}
                  />,
                  disableTranslate: true,
                  accessor: 'phoneNumber',
                  customWidth: 140,
                },
              ]}
            />
          </div>
          <Button
            color="app-default"
            size="app-sm"
            block
            className="font-weight-700 mt-3"
          >
            <Intl id="download" />
          </Button>
        </Col>
      </Row>
    </ModalForm>
  );
};

const mapDispatchToProps = ( {
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( null, mapDispatchToProps )( ContactModal );
